import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

//table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { PaginateButtonPrev, PaginateButtonNext } from "../../../../../table/pagination";

export default props => {
  return (
    <div className="react-table">
      <ReactTable
        data={props.documents}
        columns={[
          {
            Header: "Nome",
            id: "name",
            maxWidth: 250,
            accessor: 'label',
            filterable: false,


          },
          {
            Header: "File",
            id: "file",
            maxWidth: 250,
            accessor: 'name',
            filterable: false,
          },
          {
            Header: "Azioni",
            filterable: false,
            accessor: "actions",
            maxWidth: 150,
            Cell: row => (
              <div className="actionTableContainer">
                <Tooltip
                  title="Modifica"
                  enterDelay={300}
                  position="bottom-end"
                >
                  <IconButton
                    className="iconButton colorGreen colorWhite"
                    onClick={() => props.modifyId(row.original.name)}
                    size="small"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Elimina" enterDelay={300}>
                  <IconButton
                    className="iconButton colorRed colorWhite"
                    onClick={() => props.removeDocument(row.original.name)}
                    size="small"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            )
          }
        ]}
        filterable
        defaultFilterMethod={(filter, row) =>
          String(row[filter.id]) === filter.value
        }
        defaultPageSize={5}
        className="-striped -highlight"
        previousText={<PaginateButtonPrev />}
        nextText={<PaginateButtonNext />}
        pageText="Pag."
        ofText="di"
        rowsText="righe"
        noDataText="Nessun Materiale Trovato"
      />
      <br />
    </div>
  );
};
